import React, { useState, useEffect } from 'react';
import { FormControl, Grid, Checkbox, IconButton, InputAdornment, InputLabel, OutlinedInput, TextField, colors } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Link, useHistory } from 'react-router-dom';
import Select from 'react-select';
import axios from 'axios';
import { Constants } from '../endPoints';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import ReCAPTCHA from 'react-google-recaptcha';
import { MuiTelInput } from 'mui-tel-input';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";


const userRegister = `${Constants.userRegisterWithCaptcha}`;
const listCountry = `${Constants.listCounty}?page=1&limit=100&keyword`;
const checkEmailExists = `${Constants.userExitEmail}`;

export default function Register() {
  const navigate = useHistory();
  const backgroundImageUrl = 'assets/images/bg-02.jpg';
  const [showPassword, setShowPassword] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [countryOptions, setCountryOptions] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [successMessage, setSuccessMessage] = useState('');
  const [emailExistsError, setEmailExistsError] = useState('');
  const [selectedCity, setSelectedCity] = useState(null);

  const [captchaToken, setCaptchaToken] = useState(null);
  const [captchaError, setCaptchaError] = useState('');


  // Initial form values
  const initialValues = {
    name: '',
    // firstname: '',
    // lastname: '',
    email: '',
    phone: '',
    country_id: '',
    state_id: '',
    city_id: '',
    password: '',
    confirmPassword: '',
    termsAccepted: false,
  };

  // Validation schema
  // const validationSchema = Yup.object({
  //   name: Yup.string().required('Name is required'),
  //   // firstname: Yup.string().required('First Name is required'),
  //   // lastname: Yup.string().required('Last Name is required'),
  //   email: Yup.string().email('Invalid email format').required('Email is required'),
  //   password: Yup.string().required('Password is required'),
  //   confirmPassword: Yup.string()
  //     .oneOf([Yup.ref('password'), null], 'Passwords must match')
  //     .required('Confirm Password is required'),
  //   // phone: Yup.string().required('Phone is required'),
  //   phone: Yup.string()
  //     .required('Phone is required')
  //     .test(
  //       'phone-min-length',
  //       'Phone is required',
  //       (value) => {
  //         if (!value) return false;                    // null / undefined
  //         const digits = value.replace(/\D/g, '');     // sirf numbers
  //         return digits.length > 1;                    // yahan min digit set karo (ex: > 3, >= 10, etc.)
  //       }
  //     ),
  //   // country_id: Yup.string().required('Country is required'),
  //   // state_id: Yup.string().required('State is required'),
  //   // city_id: Yup.string().required('City is required'),
  //   termsAccepted: Yup.boolean()
  //     .oneOf([true], 'You must accept the terms and conditions')
  //     .required('You must accept the terms and conditions'),
  // });


  const validationSchema = Yup.object({
    name: Yup.string()
      .matches(/^[A-Za-z\s]+$/, 'Only alphabets are allowed')
      .min(2, 'Name is too short')
      .max(50, 'Name is too long')
      .required('Name is required'),

    email: Yup.string()
      .email('Invalid email format')
      .required('Email is required'),

    phone: Yup.string()
      .required('Phone is required')
      .test('valid-phone', 'Enter valid phone number', (value) => {
        if (!value) return false;
        const digits = value.replace(/\D/g, '');
        return digits.length >= 10 && digits.length <= 15;
      }),

    password: Yup.string()
      .required('Password is required')
      .min(6, 'Minimum 6 characters')
      .matches(/[A-Z]/, 'At least 1 uppercase letter')
      .matches(/[a-z]/, 'At least 1 lowercase letter')
      .matches(/[0-9]/, 'At least 1 number')
      .matches(/[@$!%*?&]/, 'At least 1 special character'),

    confirmPassword: Yup.string()
      .oneOf([Yup.ref('password'), null], 'Passwords must match')
      .required('Confirm Password is required'),

    country_id: Yup.string().required('Country is required'),
    state_id: Yup.string().required('State is required'),
    city_id: Yup.string().required('City is required'),

    termsAccepted: Yup.boolean()
      .oneOf([true], 'You must accept the terms and conditions')
  });
  // Fetch countries
  useEffect(() => {
    axios
      .get(listCountry)
      .then((response) => {
        const countries = Array.isArray(response.data.data) ? response.data.data : response.data.data.countries;
        setCountryOptions(
          countries.map((country) => ({
            value: country.id,
            label: country.country,
            code: country.country_code,
            flag: country.country_symbols,
          }))
        );
      })
      .catch((error) => console.error('Error fetching countries:', error));
  }, []);

  // Custom option display for Select component
  const formatOptionLabel = ({ label, flag, code }) => (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <img src={flag} alt={code} style={{ width: 20, height: 15, marginRight: 10 }} />
      {label}
    </div>
  );

  // Fetch states based on selected country
  useEffect(() => {
    if (selectedCountry) {
      const listState = `${Constants.getStatecountryById}/${selectedCountry.value}`;
      axios
        .get(listState)
        .then((response) => {
          setStateOptions(
            response.data.data.map((state) => ({
              value: state.id,
              label: state.name,
              code: state.state_code,
            }))
          );
        })
        .catch((error) => console.error('Error fetching states:', error));
    }
  }, [selectedCountry]);

  // Fetch cities based on selected state
  useEffect(() => {
    if (selectedState) {
      const listCity = `${Constants.getCityStateById}/${selectedState.value}`;
      axios
        .get(listCity)
        .then((response) => {
          setCityOptions(response.data.data.map((city) => ({ value: city.id, label: city.name })));
        })
        .catch((error) => console.error('Error fetching cities:', error));
    }
  }, [selectedState]);

  const handleCountryChange = (selectedOption) => {
    setSelectedCountry(selectedOption);
  };

  const handleStateChange = (selectedOption) => {
    setSelectedState(selectedOption);
  };

  const handleCityChange = (selectedOption) => {
    setSelectedCity(selectedOption); // Update selected city
  };

  const handleEmailChange = (e) => {
    const email = e.target.value;
    setEmailExistsError('');
    if (email) {
      // Use POST method to check if email already exists
      axios
        .post(checkEmailExists, { email: email })
        .then((response) => {
          if (response.data.isEmail === 1) {
            setEmailExistsError('Email is already registered.');
          }
        })
        .catch((error) => console.error('Error checking email:', error));
    }
  };

  const handleCaptchaChange = (token) => {
    setCaptchaToken(token);       // token is null if user clears
    setCaptchaError('');
  };

  const handleRegister = (values) => {
    console.log('Submit triggered');
    // Log the form values to the console (for debugging)
    console.log(values);

    // Check if email already exists
    if (emailExistsError) {
      return; // Don't proceed if the email is already registered
    }

    if (!captchaToken) {
      setCaptchaError('Please verify that you are not a robot.');
      return;
    }

    // Create the form data object
    const formData = {
      ...values,
      phone: values.phone
        ? values.phone.replace(/^(\+\d{2})(\d{10})$/, '$1 $2')
        : '',
      country_id: selectedCountry?.value, // Ensure `selectedCountry` exists
      state_id: selectedState?.value, // Ensure `selectedState` exists
      city_id: selectedCity ? selectedCity.value : '', // Optional field
      captchaToken,
    };

    console.log(formData); // Log the data before sending it

    // Call API to register the user
    axios
      .post(userRegister, formData)
      .then((response) => {
        // Assuming registration is successful
        if (response.data.status === 1) {
          setSuccessMessage('User registered successfully!');
          setTimeout(() => {
            navigate.push('/login');
          }, 2000);
          setEmailExistsError('');
          setCaptchaToken(null); // optional reset
        }
      })
      .catch((error) => {
        // Handle any errors
        console.error('Error registering user:', error);
        // Optionally display an error message to the user
      });
  };

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  return (
    <section className="register_section">
      <div className="container">
        <div className="row">
          {/* Left Side */}
          <div className="col-lg-6">
            <div style={{ backgroundImage: `url(${backgroundImageUrl})` }} className='image_col'>
              <div className="site_center_logo">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/hderlgo.png`}
                  className="mx-auto h-20"
                  alt="logo"
                />
              </div>
            </div>
          </div>

          {/* Right Side */}
          <div className="col-lg-6">
            <div className="form_section">
              <div className="form_heading pagehding text-center">
                <h2>Create Account</h2>

                {successMessage && (
                  <div className="bg-green-100 text-green-800 p-4 mb-4 rounded">
                    {successMessage}
                  </div>
                )}
              </div>

              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleRegister}
              >
                {({ handleSubmit, setFieldValue }) => (
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      handleSubmit();
                    }}
                    className="form-profile"
                  >
                    <Grid container spacing={3}>

                      {/* Name */}
                      <Grid item lg={12} md={12} xs={12}>
                        <Field name="name">
                          {({ field }) => (
                            <TextField
                              label="Name"
                              variant="outlined"
                              className="w-full rounded-lg"
                              {...field}
                              onInput={(e) => {
                                e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, '');
                              }}
                            />
                          )}
                        </Field>
                        <ErrorMessage name="name" component="div" className="text-danger" />
                      </Grid>

                      {/* Email */}
                      <Grid item lg={6} md={6} xs={12}>
                        <Field name="email">
                          {({ field }) => (
                            <TextField
                              label="Email"
                              variant="outlined"
                              className="w-full rounded-lg"
                              {...field}
                              onChange={(e) => {
                                field.onChange(e);
                                handleEmailChange(e);
                              }}
                            />
                          )}
                        </Field>
                        <ErrorMessage name="email" component="div" className="text-danger" />
                        {emailExistsError && (
                          <div className="bg-red-100 text-danger p-4 mb-4 rounded">
                            {emailExistsError}
                          </div>
                        )}
                      </Grid>

                      {/* Phone */}
                      <Grid item lg={6} md={6} xs={12}>
                        <Field name="phone">
                          {({ field, form }) => (
                            <div style={{ position: "relative" }}>

                              <MuiTelInput
                                defaultCountry="AE"
                                value={field.value || ""}
                                onChange={(value) => form.setFieldValue("phone", value)}
                                fullWidth
                                sx={{
                                  "& .MuiInputBase-input": {
                                    paddingLeft: "15px"
                                  }
                                }}
                                // MenuProps={{
                                //   PaperProps: {
                                //     sx: {
                                //       maxHeight: 200,
                                //       width: "100%",
                                //       minWidth: "100%",
                                //       overflowY: "auto"
                                //     }
                                //   }
                                // }}
                                MenuProps={{
                                  PaperProps: {
                                    sx: {
                                      maxHeight: 200,
                                      width: {
                                        xs: "92%",   // mobile
                                        sm: "280px",  // tablet
                                        md: "280px"   // desktop
                                      },
                                      minWidth: {
                                        xs: "92%",
                                        sm: "280px"
                                      },
                                      overflowY: "auto"
                                    }
                                  }
                                }}
                              />

                              {/* Arrow icon */}
                              <ArrowDropDownIcon
                                onClick={() => {
                                  const btn = document.querySelector(".MuiTelInput-FlagButton");
                                  if (btn) btn.click();
                                }}
                                style={{
                                  position: "absolute",
                                  left: "50px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  cursor: "pointer",
                                  color: "#555"
                                }}
                              />

                              {/* Vertical divider */}
                              <div
                                style={{
                                  position: "absolute",
                                  left: "70px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  width: "1px",
                                  height: "35px",
                                  backgroundColor: "#ccc"
                                }}
                              ></div>

                            </div>
                          )}
                        </Field>

                        <ErrorMessage name="phone" component="div" className="text-danger" />
                      </Grid>

                      {/* Country */}
                      {/* <Grid item lg={6} md={6} xs={12}>
                        <Select
                          options={countryOptions}
                          value={selectedCountry}
                          onChange={handleCountryChange}
                          placeholder="Select Country"
                          getOptionLabel={formatOptionLabel}
                          className="w-full rounded-lg"
                        />

                        <Select
                          options={countryOptions}
                          value={selectedCountry}
                          onChange={handleCountryChange}
                          placeholder="Select Country"
                          formatOptionLabel={formatOptionLabel}
                          isSearchable={true}
                          className="w-full rounded-lg"
                        />
                        <ErrorMessage name="country_id" component="div" className="text-danger" />
                      </Grid> */}

                      {/* State */}
                      {/* <Grid item lg={6} md={6} xs={12}>
                        <Select
                          options={stateOptions}
                          value={selectedState}
                          onChange={handleStateChange}
                          placeholder="Select State"
                          className="w-full rounded-lg"
                        />
                        <ErrorMessage name="state_id" component="div" className="text-danger" />
                      </Grid> */}

                      {/* City */}
                      {/* <Grid item lg={12} md={12} xs={12}>
                        <Select
                          options={cityOptions}
                          value={selectedCity}
                          onChange={handleCityChange}
                          placeholder="Select City"
                          className="w-full rounded-lg"
                        />
                        <ErrorMessage name="city_id" component="div" className="text-danger" />
                      </Grid> */}


                      {/* Country */}
                      <Grid item lg={6} md={6} xs={12}>
                        <Select
                          options={countryOptions}
                          value={selectedCountry}
                          onChange={(option) => {
                            setSelectedCountry(option);
                            setFieldValue('country_id', option ? option.value : '');
                            // reset dependent fields
                            setSelectedState(null);
                            setSelectedCity(null);
                            setFieldValue('state_id', '');
                            setFieldValue('city_id', '');
                          }}
                          placeholder="Select Country"
                          formatOptionLabel={formatOptionLabel}
                          isSearchable
                          className="w-full rounded-lg"
                        />
                        <ErrorMessage name="country_id" component="div" className="text-danger" />
                      </Grid>

                      {/* State */}
                      <Grid item lg={6} md={6} xs={12}>
                        <Select
                          options={stateOptions}
                          value={selectedState}
                          onChange={(option) => {
                            setSelectedState(option);
                            setFieldValue('state_id', option ? option.value : '');
                            setSelectedCity(null);
                            setFieldValue('city_id', '');
                          }}
                          placeholder="Select State"
                          className="w-full rounded-lg"
                        />
                        <ErrorMessage name="state_id" component="div" className="text-danger" />
                      </Grid>

                      {/* City */}
                      <Grid item lg={12} md={12} xs={12}>
                        <Select
                          options={cityOptions}
                          value={selectedCity}
                          onChange={(option) => {
                            setSelectedCity(option);
                            setFieldValue('city_id', option ? option.value : '');
                          }}
                          placeholder="Select City"
                          className="w-full rounded-lg"
                        />
                        <ErrorMessage name="city_id" component="div" className="text-danger" />
                      </Grid>

                          <Grid item lg={6} md={6} xs={12}>
                            <Field name="password">
                              {({ field }) => (
                                <FormControl fullWidth variant="outlined" className="mb-4">
                                  <InputLabel htmlFor="password">Password</InputLabel>
                                  <OutlinedInput
                                    id="password"
                                    name="password"
                                    type={showPassword ? 'text' : 'password'}
                                    {...field} // Spread the field props here
                                    label="Password"
                                    endAdornment={
                                      <InputAdornment position="end">
                                        <IconButton onClick={handleClickShowPassword} edge="end">
                                          {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                      </InputAdornment>
                                    }
                                  />
                                </FormControl>
                              )}
                            </Field>
                            <ErrorMessage name="password" component="div" className="text-danger"/>
                          </Grid>

                          <Grid item lg={6} md={6} xs={12}>
                            <Field name="confirmPassword">
                              {({ field }) => (
                                <FormControl fullWidth variant="outlined" className="mb-4">
                                  <InputLabel htmlFor="confirmPassword">Confirm Password</InputLabel>
                                  <OutlinedInput
                                    id="confirmPassword"
                                    name="confirmPassword"
                                    type={showPassword ? 'text' : 'password'}
                                    {...field} // Spread the field props here
                                    label="Confirm Password"
                                    endAdornment={
                                      <InputAdornment position="end">
                                        <IconButton onClick={handleClickShowPassword} edge="end">
                                          {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                      </InputAdornment>
                                    }
                                  />
                                </FormControl>
                              )}
                            </Field>
                            <ErrorMessage name="confirmPassword" component="div" className="text-danger" />
                          </Grid>


                      {/* Terms */}
                      <Grid item lg={12} md={12} xs={12}>
                        <label className="block mb-2">
                          <Field type="checkbox" name="termsAccepted" /> I accept the{" "}
                          <Link to="/terms-conditions" className="text-blue-500">
                            Terms and Conditions
                          </Link>
                        </label>
                        <ErrorMessage name="termsAccepted" component="div" className="text-danger" />
                      </Grid>

                      {/* reCAPTCHA */}
                      <Grid item lg={12} md={12} xs={12}>
                        <ReCAPTCHA
                          sitekey="6LdYMBIsAAAAALuijIdPH2_c21RXvAVKdu5ATCtW"
                          onChange={handleCaptchaChange}
                        />
                        {captchaError && (
                          <div className="text-danger mt-2">{captchaError}</div>
                        )}
                      </Grid>

                      {/* Buttons */}
                      <Grid item lg={12} md={12} xs={12}>
                        <div className="mb-5 text-center">
                          <button type="submit" class="createAcct_btn">
                            Create Account
                          </button>
                        </div>

                        <div className="mt-10 text-center">
                          <p className="mb-4">Already have account?</p>
                          <Link to="/login" className="text-center link_btn">
                            Login
                          </Link>
                        </div>
                      </Grid>

                    </Grid>
                  </Form>
                )}
              </Formik>

              {/* Bottom Login Text */}
              <div className="text-center mt-5">
                <span className="text-sm">
                  Already have an account?{" "}
                  <Link to="/login" className="text-primary">
                    Login
                  </Link>
                </span>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  );

}
